/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'alert';

export const alertActionBreadcrumbTitle = `${prefix}.alertActionBreadcrumbTitle`;
export const alertConfigModalBreadcrumbTitle = `${prefix}.alertConfigModalBreadcrumbTitle`;
export const alertSyslogServerBreadcrumbTitle = `${prefix}.alertSyslogServerBreadcrumbTitle`;
export const alertSnmpTrapProfileBreadcrumbTitle = `${prefix}.alertSnmpTrapProfileBreadcrumbTitle`;
export const alertSnmpTrapServereBreadcrumbTitle = `${prefix}.alertSnmpTrapServereBreadcrumbTitle`;

export const ENGLISH = {
    [alertActionBreadcrumbTitle]: 'Alert Action',
    [alertConfigModalBreadcrumbTitle]: 'Alert Config',
    [alertSyslogServerBreadcrumbTitle]: 'Syslog Server',
    [alertSnmpTrapProfileBreadcrumbTitle]: 'SNMP Trap Profile',
    [alertSnmpTrapServereBreadcrumbTitle]: 'SNMP Trap Server',
};
